module.exports = __webpack_public_path__ + "img/star.bdebec88.svg";